import { FormControl, FormField, FormItem } from 'ui'
import { useSigningForm } from '../Provider'
import { SigningFormFieldProps } from './Switcher'
import { Control, FieldValues } from 'react-hook-form'

export const ControlledField = ({
  path,
  children,
  formControl,
}: Partial<SigningFormFieldProps> & {
  children: React.ComponentProps<typeof FormField>['render']
  formControl: Control<FieldValues>
}) => {
  return (
    <FormField
      control={formControl}
      name={path}
      render={(props) => {
        return (
          <FormItem className='w-full h-full'>
            <FormControl className='w-full h-full'>
              {children(props)}
            </FormControl>
          </FormItem>
        )
      }}
    />
  )
}
